// Based on the minivents library
class Eventable {
  constructor() {
    this._events = {};
  }

  on(type, func, ctx) {
    this._events[type] = this._events[type] || [];
    this._events[type].push({ func: func, ctx: ctx });
  }

  off(type, func) {
    if (!type) {
      this._events = {};
      return;
    }

    let list = this._events[type] || [];
    let i = (list.length = func ? list.length : 0);
    while (i--) {
      func === list[i].func && list.splice(i, 1);
    }
  }

  emit(type, ...params) {
    let events = this._events[type] || [];

    events.forEach(e => {
      e.func.call(e.ctx || this, ...params);
    });
  }
}

export default Eventable;



// WEBPACK FOOTER //
// ./src/javascripts/toolkit/eventable.js